export const validate_mixins = {
  methods: {
    m__check_times(times) {
      if (!times || !times.length) return false
      else if (!times.every(i => !!i.start_time)) return false
      else if (!times.every(i => !!i.end_time)) return false

      return true
    },

    m__check_advanced_times(advanced_times) {
      if (!advanced_times || !advanced_times.length) return false
      else if (!advanced_times.every(i => !!i.advanced_start_time)) return false
      else if (!advanced_times.every(i => !!i.advanced_end_time)) return false

      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validate.js